/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
// components

import IndexDropdown from "components/Dropdowns/IndexDropdown.js";

export default function Navbar(props) {
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  return (
    <>
      <div className="w-full  md:px-4  flex flex-wrap md:text-right border-b justify-between">
        <h6></h6>
        <h6 className=" container mx-auto text-darkSlate py-2 pr-4  justify-center text-right"><i className="fas fa-envelope-open text-blueMagenta text-lg  " /> enquiry@24by7rescuelink.com   <i className="text-blueMagenta fas fa-phone-volume text-lg leading-lg pl-4" />  03-79627056 </h6>
      </div>
      <nav className=" relative z-50 w-full  items-center justify-between px-2 bg-white shadow">

        <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <Link
              to="/"
              className="text-blueGray-700 text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase"
            >
              <img
                alt="..."
                src={require("assets/img/logo.png").default}
                className="w-full align-left max-w-150-px z-3 right-150-px "
              />
            </Link>
            <button
              className="cursor-pointer text-xl leading-none px-3 py-1   border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <i className="fas fa-bars"></i>
            </button>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center bg-white lg:bg-opacity-0 lg:shadow-none" +
              (navbarOpen ? " block" : " hidden")
            }
            id="example-navbar-warning"
          >
            {/*} <ul className="flex flex-col lg:flex-row list-none mr-auto">
              <li className="flex items-center">
                <a
                  className="hover:text-blueGray-500 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href="https://www.creative-tim.com/learning-lab/tailwind/react/overview/notus?ref=nr-index-navbar"
                >
                  <i className="text-blueGray-400 far fa-file-alt text-lg leading-lg mr-2" />{" "}
                  Docs
                </a>
              </li>
          </ul>*/}
            <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">

              <li className="flex items-center">
                <Link
                  to="/index"
                  className="hover:text-blueMagenta  text-darkSlate px-2 py-4 lg:py-2 flex items-center text-base uppercase font-bold"
                >
                  Home
                </Link>
              </li>

              <li className="flex items-center">
                <Link
                  to="/about"
                  className="hover:text-blueMagenta  text-darkSlate px-2 py-4 lg:py-2 flex items-center text-base uppercase font-bold"
                >
                  About Us
                </Link>
              </li>

              <li className="flex items-center">
                <Link
                  to="/career"
                  className="hover:text-blueMagenta text-darkSlate px-2 py-4 lg:py-2 flex items-center text-base uppercase font-bold"
                >
                  Career
                </Link>
              </li>

              <li className="flex items-center">
                <Link
                  to="/investment"
                  className="hover:text-blueMagenta text-darkSlate px-2 py-4 lg:py-2 flex items-center text-base uppercase font-bold"
                >
                  Investors
                </Link>
              </li>

              <li className="flex items-center">
                <Link
                  to="/vendor"
                  className="hover:text-blueMagenta text-darkSlate px-2 py-4 lg:py-2 flex items-center text-base uppercase font-bold"
                >
                  Vendor
                </Link>
              </li>

              <li className="flex items-center">
                <Link
                  to="/contact"
                  className="hover:text-blueMagenta text-darkSlate px-2 py-4 lg:py-2 flex items-center text-base uppercase font-bold"
                >
                  Contact Us
                </Link>
              </li>

              <li className="flex items-center">
                <a
                  className="hover:text-blueGray-500 text-blueGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href="https://www.facebook.com/24by7rescuelink/"
                  target="_blank"
                >
                  <i className="text-darkSlate fab fa-facebook text-lg leading-lg " />
                  <span className="lg:hidden inline-block ml-2">Share</span>
                </a>
              </li>

              <li className="flex items-center">
                <a
                  className="hover:text-blueGray-500 text-darkSlate px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href="https://twitter.com/24by7rescuelink?t=JfS_rpOuZ8REK-pgP9zH7Q&s=09"
                  target="_blank"
                >
                  <i className="text-darkSlate fab fa-twitter text-lg leading-lg " />
                  <span className="lg:hidden inline-block ml-2">Tweet</span>
                </a>
              </li>

              <li className="flex items-center">
                <a
                  className="hover:text-blueGray-500 text-darkSlate px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href="https://www.linkedin.com/company/24-7-rescue-link"
                  target="_blank"
                >
                  <i className="text-darkSlate fab fa-linkedin text-lg leading-lg " />
                  <span className="lg:hidden inline-block ml-2">FOLLOW</span>
                </a>
              </li>

              <li className="flex items-center">
                <a
                  className="hover:text-blueGray-500 text-darkSlate px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href="https://instagram.com/24by7rescuelink?igshid=YmMyMTA2M2Y="
                  target="_blank"
                >
                  <i className="text-darkSlate fab fa-instagram text-lg leading-lg " />
                  <span className="lg:hidden inline-block ml-2">FOLLOW</span>
                </a>
              </li>

              {/* <li className="flex items-center">
                <button
                  className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150"
                  type="button"
                >
                  <i className="fas fa-arrow-alt-circle-down"></i> Download
        </button>
        </li>*/}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
